/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EchoPaymentMethod {
  VIRTUAL_CARD = 'Virtual Card',
  DIRECT_ACH = 'Direct ACH',
}
